export default __webpack_public_path__ + "static/media/intro1.f04fba84.mp3";